export const fakeLogin = {
    bookingnumber: '300188440',
    lastname: 'Aurumtours',
    travelstart: '18.09.2026',
};

export type FakeLogin = typeof fakeLogin;
